import React from 'react'

import "./style/contato.css";
import { borderColor, fontSize, textAlign, width } from '@mui/system';

const Contato = () => {
    return (
        <div className='contatomormor' id="contato">
            <h6>CADASTRE-SE PARA O LANÇAMENTO</h6>
            <div className='contatomor'>
                <div className='contatosemimor'>
                <div className='contatoT'>
                            <p className="text_info" data-aos="fade-up" data-aos-duration="1500" >
                            <br/>
                            <b style={{textTransform:'uppercase'}}>Entre em contato pelo WhatsApp</b> <br/>
                            <a href="https://api.whatsapp.com/send?phone=5541996480900" style={{color:'inherit'}}>41 99648.0900 </a><br/>
                            <br/>
                            <b style={{textTransform:'uppercase'}}>Siga-nos no Instagram</b> <br/>
                            <a style={{color:'inherit'}}href="https://www.instagram.com/concrezatto_construtora/?igshid=OTJlNzQ0NWM%3D">@concrezatto_construtora </a><br/>
                            <br/>
                              <b style={{textTransform:'uppercase'}}>Endereço</b> <br/>
                            <a style={{color:'inherit'}}href="">Rua Alameda Prudente de Moraes, 298 - Mercês </a><br/>
                            <br/>
                            <b style={{textTransform:'uppercase'}}>Venda exclusiva</b> <br/>
                            Concrezatto Construtora<br/>
                        </p>
                </div>
                <div className='contatoForm'>
                    <h6 style={{paddingTop:'0',  marginBottom:'2rem'}}>Link direto para<br/> nosso WhatsApp!</h6>
                      <a href="https://api.whatsapp.com/send?phone=5541996480900"className="custom-btn btn-15 aos-init aos-animate" style={{color:'white', borderColor:'white', textAlign:'center', fontSize:'1.3rem', width:''}}>
                         <a href="https://api.whatsapp.com/send?phone=5541996480900"><img src="whatsapp.png" style={{width:'25px', filter: "invert(1)", marginRight:'10px', marginTop:'auto', marginBottom:'auto'}}/></a>
                        WhatsApp 
                       
                </a>
                </div>
            </div>
            </div>
        </div>
    )
}

export default Contato